/* Progressive reveal for collection grids: 25 cards on load, +25 per "Show More" click.
   Composes with ef-collection-filter.js — the filter hides non-matching cards via the
   [hidden] property; this layer only caps the cards the filter left visible using the
   .ef-card-capped class, and resets to 25 whenever the filter or sort changes
   (ef:collf:applied). The card pool comes from ef-collection-rest.js: 25 rendered in the
   document plus the tail it fetched from ?view=cards. STEP must match the limit in the
   collection templates and the offset in templates/collection.cards.liquid. */
(function () {
  'use strict';
  var STEP = 25;

  function init() {
    var grid = document.querySelector('.ef-coll-grid');
    var wrap = document.querySelector('[data-ef-more]');
    if (!grid || !wrap) return;
    var btn = wrap.querySelector('[data-ef-more-btn]');
    var limit = STEP;
    if (!window.EFCollectionCards) {
      window.EFCollectionCards = window.EFCollectionRest
        ? window.EFCollectionRest.cards.slice()
        : Array.prototype.slice.call(grid.querySelectorAll('.ef-coll-card'));
    }

    function applyCap() {
      var cards = window.EFCollectionCards || Array.prototype.slice.call(grid.querySelectorAll('.ef-coll-card'));
      var visible = cards.filter(function (card) { return !card.hidden; });
      var rendered = visible.slice(0, limit);
      cards.forEach(function (card) {
        card.classList.remove('ef-card-capped');
        if (card.parentNode === grid) card.remove();
      });
      var fragment = document.createDocumentFragment();
      rendered.forEach(function (card) { fragment.appendChild(card); });
      grid.appendChild(fragment);
      var capped = Math.max(0, visible.length - rendered.length);
      wrap.hidden = capped === 0;
      if (btn && capped > 0) {
        btn.textContent = 'Show More (' + capped + ' remaining)';
      }
    }

    if (btn) {
      btn.addEventListener('click', function () {
        limit += STEP;
        applyCap();
      });
    }
    document.addEventListener('ef:collf:applied', function () {
      limit = STEP;
      applyCap();
    });
    applyCap();
  }

  function boot() {
    if (window.EFCollectionRest) window.EFCollectionRest.ready(init);
    else init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
